<template>
  <el-container class="model" direction="vertical">
    <div class="model_top">
      <el-button v-permission="'新增设备型号'" class="btn btn_1" @click="dialogVisible = true">新增型号</el-button>
    </div>

    <div class="model_content">
      <el-collapse v-model="activeNames">
        <el-collapse-item v-for="item in deviceTypeList" :key="item.device_type_id" :title="item.device_type_name" :name="item.device_type_id">
          <ul class="uList">
            <li v-for="model in getOneDeviceModelList(item.device_type_id)" :key="model.device_model_id" @click="deviceModelChoose(model.device_type_id, model.device_model_id)" :class="{active: activeModelId === model.device_model_id}">
              <edit-input name="设备型号" :inputVal="model.device_model_name" :disabled="!hasRight('编辑设备型号')" @editRow="(val)=>editRow(model, val)" class="edit-input" />
              <i v-if="hasRight('删除设备型号')" v-show="activeModelId === model.device_model_id" class="el-icon-delete" @click.stop="deleteRow(model)"></i>
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>

    <el-dialog width="600px" title="新增设备型号" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @closed="$refs.modelAdd.resetForm()">
      <add-model ref="modelAdd" :deviceTypeList="deviceTypeList" @tableCloseDialog="dialogVisible = false" />
    </el-dialog>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import EditInput from '@/components/edit-input'
import AddModel from './add_model.vue'
import { hasRight } from '@/api/permission'

export default {
  name: '',
  data () {
    return Backend.initListPage(this, 'device_model', {
      route_name: '设备型号列表',
      id_name: 'device_model_id',
      params: {
        max_results: 1000
      },
      hasRight: hasRight,
      deviceTypeList: [],
      activeNames: [],
      dialogVisible: false,
      activeModelId: null
    })
  },

  components: {
    EditInput,
    AddModel
  },

  created () {
    this.getDeviceTypeList()
  },

  methods: {
    getDeviceTypeList () {
      Backend.get(this, '/device_type/cmd/query/first/-1/max_results/100/filter/', 30).then(data => {
        this.deviceTypeList = data.items
      })
    },
    getOneDeviceModelList (id) {
      return this.pageData.items.filter(it => it.device_type_id === id)
    },
    deviceModelChoose (deviceTypeId, deviceModelId) {
      if (this.activeModelId !== deviceModelId) {
        this.activeModelId = deviceModelId
        this.$emit('deviceModelChoose', { deviceTypeId: deviceTypeId, deviceModelId: deviceModelId })
      }
    },
    editRow (row, val) {
      const params = { device_model_id: row.device_model_id, device_model_name: val }
      Backend.editRow(this, params, undefined, '设备型号')
    },
    deleteRow (row) {
      Backend.deleteRow(this, row, '设备型号').then(() => {
        this.$emit('deviceModelDelete')
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.model{
  height: 100%;
  border-right: 1px solid #e6e6e6;
  .model_top{
    text-align: right;
    padding: 10px 10px 10px 0;
  }
  .model_content{
    overflow: auto;
    .uList{
      li{
        padding: 8px 20px;
        background: rgba(27, 197, 215, 0.1);
        border-bottom: 1px solid #e3e5e8;
        &:hover{
          background: rgba(27, 197, 215, 0.2);
        }
        .edit-input{
          display: inline-block;
        }
        .el-icon-delete{
          margin-left: 10px;
          color: red;
          cursor: pointer;
        }
      }
      li.active{
        background: rgba(27, 197, 215, 0.5);
      }
    }
  }
}
</style>
